module.exports = __webpack_public_path__ + "./images/989a6c79e569c6dd45a36e99abfccc4c.webp";